import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import TransportReportListComponent from "./views/TransportReportList";

const TransportReportList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <TransportReportListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Transport Report",
          description: "transport report section"
        })}
      />
      <Routes>
        <Route path={""} element={<TransportReportList />} />
      </Routes>
    </>
  );
};

export default Component;
